/**
 * Created by SHANG on 2017/4/26.
 */
var typeObj = {
    WF: '钱包',
    GFP: '普通基金',
    HFP: '高端',
    TP: '目标盈',
    ZY: '招行止盈',
    PSA: '跟我投',
    CUST: '跟我投',
    COMB: '官方组合',
    TY: '止盈定投',
    IP: '智能定投',
    STG: '投顾',
    GSDY: '养老产品'
}

var result;
var totalCounts;


$(function () {
    var cardLen = loadValue('cardLen', false);
    if (!isRealName() || isNull(cardLen) || Number(cardLen) <= 0) {
        var noneHtml = '<div class="hold-box h-min">';
        noneHtml += '<p class="no-data">暂无收益记录</p>';
        noneHtml += '</div>';
        $('#surely-list').html(noneHtml);
    } else {
        var pageno = 1;
        // getData(pageno);
        getList(pageno);
    }
});

function getData(pagno) {

    var params = {
        pageNo: pagno,
        pageSize: 10,
        onlyOrdinaryFundIncomeFlag: 1
    };
    toApi_toAc('S091536', params, function (data) {
        var fundIncomeList = data.fundIncomeList || [];
        var totalCounts = data.count;

        if (totalCounts === 0) {
            var noneHtml = '<div class="hold-box h-min">';
            noneHtml += '<p class="no-data">暂无收益记录</p>';
            noneHtml += '</div>';
            $('#surely-list').html(noneHtml);
        } else {

            var list = fundIncomeList.map(function (fund) {
                var totalIncome = fund.totalIncome;
                var obj = numberFormatter(totalIncome, 2);

                return {
                    fundName: fund.productName,
                    fundCode: fund.productCode,
                    profitLoss: obj.value,
                    profitLossColor: obj.color,
                    isNocPortfolioFlag: fund.isNocPortfolioFlag
                }
            });

            var htmlList = template('incomeList', { "list": list });
            $('#incomeTable').html(htmlList);

            var htmlPage = template('pageBlock', {
                fun: "toPage",
                index: pagno,
                pages: Math.ceil(data.count / 10)
            });
            $('#page').html(htmlPage);
        }
    });
}

function getList(pagno) {

    var params = {
        classesType: getParamsByName('classesType')
    };
    if (!isNull(result) && result.length > 0) {
        var fundIncomeList = result.slice(10 * (pagno - 1), 10 * pagno);

        var list = fundIncomeList.map(function (fund) {
            var totalIncome = fund.profitAmountTotal;
            var obj = numberFormatter(totalIncome, 2);
            var qingcangFlag = false;

            if (params.classesType == '03') {
                if (fund.availableAmount == 0 && fund.totalAmount == 0) {
                    qingcangFlag = true;
                }
            } else {
                if (fund.availableShare == 0 && fund.frozenShare == 0) {
                    qingcangFlag = true;
                }
            }

            return {
                fundName: fund.fundName || fund.portfolioName,
                productCode: fund.portfolioCode || fund.fundCode,
                profitLoss: obj.value,
                profitLossColor: obj.color,
                isNocPortfolioFlag: fund.isNocPortfolioFlag,
                fundCode: typeObj[fund.portfolioType] || fund.fundCode,
                transAcctIdSub: fund.transAcctIdSub,
                productTypeCode: fund.portfolioType,
                shareType: fund.shareType,
                qcFlag: qingcangFlag
            }
        });

        var htmlList = template('incomeList', { "list": list });
        $('#incomeTable').html(htmlList);

        var htmlPage = template('pageBlock', {
            fun: "toPage",
            index: pagno,
            pages: Math.ceil(totalCounts / 10)
        });
        $('#page').html(htmlPage);
    } else {
        toApi_toAcCg('S15Q132', params, function (data) {
            result = data.result || [];
            var fundIncomeList = result.slice(10 * (pagno - 1), 10 * pagno);
            totalCounts = data.size;

            if (totalCounts === 0) {
                var noneHtml = '<div class="hold-box h-min">';
                noneHtml += '<p class="no-data">暂无收益记录</p>';
                noneHtml += '</div>';
                $('#surely-list').html(noneHtml);
            } else {
                var totalAmount = numberFormatter(data.totalAmount, 2);
                $('#allIncome').html('<span style="color:' + totalAmount.color + '">' + totalAmount.value + '</span>');

                var list = fundIncomeList.map(function (fund) {
                    var totalIncome = fund.profitAmountTotal;
                    var obj = numberFormatter(totalIncome, 2);
                    var qingcangFlag = false;

                    if (params.classesType == '03') {
                        if (fund.availableAmount == 0 && fund.totalAmount == 0) {
                            qingcangFlag = true;
                        }
                    } else {
                        if (fund.availableShare == 0 && fund.frozenShare == 0) {
                            qingcangFlag = true;
                        }
                    }


                    return {
                        fundName: fund.fundName || fund.portfolioName,
                        productCode: fund.portfolioCode || fund.fundCode,
                        profitLoss: obj.value,
                        profitLossColor: obj.color,
                        isNocPortfolioFlag: fund.isNocPortfolioFlag,
                        fundCode: typeObj[fund.portfolioType] || fund.fundCode,
                        transAcctIdSub: fund.transAcctIdSub,
                        productTypeCode: fund.portfolioType,
                        shareType: fund.shareType,
                        qcFlag: qingcangFlag
                    }
                });

                var htmlList = template('incomeList', { "list": list });
                $('#incomeTable').html(htmlList);

                var htmlPage = template('pageBlock', {
                    fun: "toPage",
                    index: pagno,
                    pages: Math.ceil(totalCounts / 10)
                });
                $('#page').html(htmlPage);
            }
        });
    }

}

function toPage(type, currPage, totalPage) {
    if (type == 0) {
        if (currPage - 1 != 0) {
            getList(currPage - 1);
        }
    } else if (type == 1) {
        if (currPage + 1 <= totalPage) {
            getList(currPage + 1);
        }
    } else {
        var val = parseInt($("#toPage").html());
        if (val >= 1 && val <= totalPage && val != currPage) {
            getList(val);
        }
    }
}

function back() {
    if (!isNull(localStorage.whoCometoMyFundInCome)) {
        window.location.href = phURL + localStorage.whoCometoMyFundInCome;
        localStorage.whoCometoMyFundInCome = "";
    } else {
        window.location.href = phURL + "fund/myFund.html";
    }
}